import { render, staticRenderFns } from "./model-order.vue?vue&type=template&id=72688dbb&scoped=true&"
import script from "./model-order.vue?vue&type=script&lang=js&"
export * from "./model-order.vue?vue&type=script&lang=js&"
import style0 from "./model-order.vue?vue&type=style&index=0&id=72688dbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72688dbb",
  null
  
)

export default component.exports